import { getRoomName } from "@Pages/BookForm/utils";
import getMoveIn from "@Utils/getMoveIn";

const encodeParam = (key: string, value: string) => `${key}=${encodeURIComponent(value)}`;

/**
 * Booking summary fields passed to the native WeChatPay page via URL query params.
 */
const buildWeChatPayBookingParams = (
  inventory: Record<string, any> | null | undefined,
  accommodationDetails: Record<string, any> | null | undefined,
): string[] => {
  if (!inventory || !accommodationDetails) return [];

  const params: string[] = [];
  const locality =
    inventory?.location?.locality?.long_name || inventory?.location?.region?.long_name || "";
  const propertyName =
    locality && inventory?.name ? `${inventory.name}, ${locality}` : inventory?.name || "";

  const roomType = getRoomName(inventory, accommodationDetails.roomType) || "";
  const duration = accommodationDetails.custom_duration || accommodationDetails.duration || "";
  const moveIn =
    getMoveIn(accommodationDetails, inventory) || accommodationDetails.arrival_date || "";

  if (propertyName) params.push(encodeParam("property_name", propertyName));
  if (roomType) params.push(encodeParam("room_type", roomType));
  if (duration) params.push(encodeParam("duration", String(duration)));
  if (moveIn) params.push(encodeParam("move_in", String(moveIn)));

  return params;
};

export default buildWeChatPayBookingParams;
